import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AIService {
  aiResponseSubject$: Subject<string> = new Subject();
}
